import {unwrapResult} from '@reduxjs/toolkit';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {requestOK} from 'redux-thunk-kit';
import {Col, Row, UiDivider, UiQuestionnaireLayout, UiSimpleGrid, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {useInput, useRequestState} from '~/hooks';
import {setMedicalUUID, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {redirectInIframe} from '~/utils/helpers';

interface Props {}

const Questionnaire12Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const {loading} = useRequestState(submitOrLogMdq);
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const [redirectLoading, setRedirectLoading] = useState(false);
  const {methodKey, medicalUUID, answerOrder} = mdq;

  const collectedData = mdq.collectedData;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE);

  const currentUser = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.PROFILE]?.data?.user,
  );

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE]?.data,
  );

  const {inputs, setInputs} = useInput({
    productId: currentAnswer?.productId || questionnaire?.packages?.[0]?.productId || '',
  });

  const onClickSubmit = async () => {
    const questionnaireAnswer = {
      key: WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE,
      index: questionnaire?.index || '',
      data: inputs,
      order: answerOrder + 1,
    };
    dispatch(setQuestionnaireAnswer(questionnaireAnswer));
    const res = await dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'submitted',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE]: questionnaireAnswer,
          },
        },
      }),
    );

    if (requestOK(res, submitOrLogMdq)) {
      const result = unwrapResult(res);
      if (result.getCheckoutUrl) {
        setRedirectLoading(true);
        redirectInIframe(result.getCheckoutUrl);
      }
    }

    if (res.payload?.errMsg === 'Medical Form invalid') {
      dispatch(setMedicalUUID({uid: null}));
      history.replace(PAGE_URLS.MDQ1_HOME);
    }

    // let currentDataAptRef = currentAptRefAnswer;
    // if (currentAptRefAnswer?.selectedOption) {
    //   const {selectedOption, ...rest} = currentAptRefAnswer;
    //   currentDataAptRef = rest;
    // }

    // const resAction = await dispatch(
    //   addQuestionnaire({
    //     data: {
    //       data: {
    //         ...medicalQuestionnaireAnswer,
    //         [WEIGHT_LOSS_KEYS.PROFILE]: {data: {user: {...currentUser, height, weight}}},
    //         [WEIGHT_LOSS_KEYS.YOUR_TEST_PACKAGE]: {...questionnaireAnswer},
    //         [WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES]: {
    //           ...medicalQuestionnaireAnswer[WEIGHT_LOSS_KEYS.APPOINTMENT_PREFERENCES],
    //           data: currentDataAptRef,
    //         },
    //       },
    //       wpUserId: wpAuthUser?.wpUserId,
    //       methodKey: METHOD_KEYS.WEIGHT_LOSS_PROGRAM,
    //     },
    //   }),
    // );
    // if (requestOK(resAction, addQuestionnaire)) {
    //   const result = unwrapResult(resAction);
    //   const appointmentAction = await dispatch(
    //     bookAppointment({
    //       data: {startTime: null, userQuestionnaireId: result?.medical?.id},
    //       platform: isWebview ? 1 : 2,
    //     }),
    //   );
    //   if (requestOK(appointmentAction, bookAppointment)) {
    //     const bookResult = unwrapResult(appointmentAction);
    //     if (bookResult?.checkoutURL) {
    //       redirectInIframe(bookResult?.checkoutURL, '_self');
    //     }
    //   }
    // }
  };

  return (
    <UiQuestionnaireLayout
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      disableNext={!inputs?.productId || loading || redirectLoading}
      loading={loading || redirectLoading}
      pageTitle={questionnaire?.title}
    >
      <Col alignItems="center" textAlign="center" mt={8} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={5}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiSimpleGrid minChildWidth={['100%', '345px']} spacing="20px">
          {questionnaire?.packages?.map(value => (
            <Col
              key={value?.label}
              bg="white"
              style={{
                boxShadow: '0px 6px 25px rgba(0, 0, 0, 0.1)',
                borderRadius: '16px',
                cursor: 'pointer',
                border: inputs?.productId === value?.productId ? '2px solid #CCDF75' : 'none',
              }}
              px={4}
              py={10}
              onClick={() => setInputs({productId: value?.productId})}
              mx={1}
            >
              <UiText fontWeight={600} fontSize="xl">
                {value?.label}
              </UiText>
              <UiText fontWeight={600} fontSize="1.375rem" my={2}>
                {value?.prefix}
                {value?.price}
                {value?.suffix}
              </UiText>
              <UiText fontWeight={600} fontSize="sm" mb={4}>
                {value?.promoMessage}
              </UiText>
              <UiText fontSize={14}>{value?.description}</UiText>
              <UiText fontWeight={600} fontSize="sm" mt={6} mb={4}>
                {value?.typePrefix} {value?.type}
              </UiText>
              <UiText fontSize="xs">{value?.howItWorks}</UiText>
              <UiDivider color="black" my={5} />
              <Row justify="center" w="100%">
                {value?.includes?.map(el => (
                  <Row
                    minH={10}
                    key={el?.key}
                    mx={1}
                    style={{
                      border: '1px solid rgba(44, 65, 66, 0.10)',
                      borderRadius: '0.5rem',
                    }}
                    textAlign="center"
                    align="center"
                    px={2}
                  >
                    <UiText fontSize="0.625rem" fontWeight={600}>
                      {el?.label}
                    </UiText>
                  </Row>
                ))}
              </Row>
            </Col>
          ))}
        </UiSimpleGrid>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire12Screen;
